import {useEffect, useState} from "react";
import {useMutation} from "react-query";
import {httpGET} from "../../utils/ajaxHelper";
import AGButton from "../Button";

import {Formik, FormikProps} from "formik";
import {useContext, useRef} from "react";
import {
  Address,
  AgnetRegion,
  ComMainService,
  CompracticeLevel,
  FirmAddress,
  Individual,
  SecondaryInterestType,
} from "../../models";
import AGSelect from "../AgSelect";

import {UserContext} from "../../Provider";
import {httpPOST} from "../../utils/ajaxHelper";
import {CommerceCompassStyled, CustomBackground} from "./modalSecondment.styled";

import moment from "moment";
import {useParams} from "react-router-dom";
import {CommerceSecondmentSchema} from "../../Schema/CommerceCompassSchema";
import {ADMIN_ORGANIZATION, MODAL_CONSTANT} from "../../utils/constant";
import AGCheckbox from "../Checkbox";
import AGModal from "../Modal";
import {useNotification} from "../Notification";
import {RolesHandle} from "../RolesHandle";
import {default as AGtextarea} from "../Textarea";
import Tooltip from "../Tooltip";
import AGInput from "../Input";
import { title } from "process";

export interface AddSecondmentModalProps {
  visible: boolean;
  toggleModal: () => void;
  submitComplete: () => void;
}
const AddSecondmentModal = ({visible, toggleModal, submitComplete}: AddSecondmentModalProps) => {
  const handleClose = () => {
    toggleModal();
  };
  const {showNotification} = useNotification();
  const [submitCount, setSubmitCount] = useState<number>(0);
  const {id} = useParams();
  const [agnetRegion, setAgnetRegion] = useState<AgnetRegion[]>();
  const [addAgnetRegion, setAddAgnetRegion] = useState<AgnetRegion[]>();
  const [firmAddresses, setFirmAddresses] = useState<Address[]>();
  const [comMainService, setComMainService] = useState<ComMainService[]>([]);
  const [individual, setIndividual] = useState<Individual[]>();

  const [expertiseServices, setExpertiseServices] = useState<any>();
  const formRef = useRef<FormikProps<any>>(null);
  const componentRef = useRef<HTMLDivElement>(null);
  const user = useContext(UserContext);
  const [, setCompracticeLevel] = useState<CompracticeLevel[]>();
  const [submitType, setSubmitType] = useState<"Draff" | "Publish" | undefined>(undefined);
  const [selectedDate, setSelectedDate] = useState(undefined);
  const [interestType, setInterestType] = useState<SecondaryInterestType[]>();

  const {mutate: getAgnetRegion} = useMutation(
    (firmId: number | undefined) =>
      httpGET({
        url: "/agnetregion/secondment",
        params: {firmId: firmId, type: "SECONDMENT"},
      }),
    {
      onSuccess: (rs) => {
        setAgnetRegion(rs as AgnetRegion[]);
      },
    },
  );
  const {mutate: getAddEditAgnetRegion} = useMutation(
    (firmId: number | undefined) =>
      httpGET({
        url: "/agnetregion/add-edit",
        params: {firmId: firmId},
      }),
    {
      onSuccess: (rs) => {
        setAddAgnetRegion(rs as AgnetRegion[]);
      },
    },
  );

  const {mutate: getIndividuals} = useMutation(
    (id: number) =>
      httpGET({
        url: "/Individuals",
        params: {id},
      }),
    {
      onSuccess: (rs) => {
        setIndividual(rs as Individual[]);
      },
    },
  );

  const {mutate: getCompracticeLevel} = useMutation(
    () =>
      httpGET({
        url: "/compracticeLevel",
      }),
    {
      onSuccess: (rs) => {
        setCompracticeLevel(rs as CompracticeLevel[]);
      },
    },
  );

  const {mutate: getInterestTypes} = useMutation(
    async () => {
      const response = await httpGET({url: "/CommerceFirmData/interestTypes"});
      return response;
    },
    {
      onSuccess: (rs) => {
        if (!Array.isArray(rs)) {
          console.error("API response is not an array:", rs);
          return;
        }

        const formattedInterestTypes = rs.map((e) => ({
          secondmentInterestTypeId: e.secondmentInterestTypeId,
          secondmentInterestType: e.secondmentInterestType,
          isChecked: false,
        }));

        setInterestType(formattedInterestTypes as SecondaryInterestType[]);
      },
      onError: (error) => {
        console.error("Error fetching interest types:", error);
      },
    },
  );

  const {mutate: getComMainServices} = useMutation(
    () =>
      httpGET({
        url: "/ComMainService",
        params: {type: "SECONDMENT"},
      }),
    {
      onSuccess: (rs) => {
        setComMainService(rs as ComMainService[]);
      },
    },
  );

  const {mutate: getFirmAddresses} = useMutation(
    (par: any) =>
      httpGET({
        url: "/firm/firm-addresses",
        params: {...par, type: "SECONDMENT"},
      }),
    {
      onSuccess: (rs) => {
        setFirmAddresses(rs as FirmAddress[]);
      },
    },
  );
  const {mutate: submitForm, isLoading: isLoadingSubmitForm} = useMutation(
    (data: FormData) =>
      httpPOST({
        url: "/CommerceFirmData/secondment",
        data: data,
      }),
    {
      onSuccess: (rs) => {
        handleClose();
        formRef.current?.resetForm();
        setSubmitCount(0);
        if (submitType === "Draff") {
          handleClose();
        } else {
          submitComplete();
        }
        setSubmitType(undefined);
      },
      onError: (rs: any) => {
        showNotification(rs.message, "Error");
      },
    },
  );

  const {mutate: getServices} = useMutation(
    (firmId: number) =>
      httpGET({
        url: `/ExpertiseService/secondment?firmId=${firmId}`,
      }),
    {
      onSuccess: (rs) => {
        setExpertiseServices(rs);
      },
      onError: (rs: any) => {
        showNotification(rs.message, "Error");
      },
    },
  );

  useEffect(() => {
    getFirmAddresses({id: user!.firmAddress?.netRegion, firmId: Number(id)});
    getIndividuals(Number(id));
    getAgnetRegion(user?.individual?.fkOrgId !== id ? Number(id) : user?.individual?.fkOrgId);
    getAddEditAgnetRegion(user?.individual?.fkOrgId);
    getComMainServices();
    getCompracticeLevel();
    getServices(Number(id));
    getInterestTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAgnetRegion, getComMainServices, getCompracticeLevel, visible, Number(id)]);

  useEffect(() => {
    if (submitType !== undefined && !isLoadingSubmitForm) {
      formRef.current?.submitForm();
      setSubmitCount(submitCount + 1);
      setSubmitType(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitType]);

  if (!agnetRegion || !id || !firmAddresses) {
    return null;
  }

  const regionId = firmAddresses?.find((e) => e.fkOrgId === Number(id))?.netRegion;

  return (
    <AGModal
      toggleModal={() => {
        toggleModal();
        setSubmitCount(0);
        setSelectedDate(undefined);
      }}
      title="Add Secondment"
      footer={
        <>
          {" "}
          <AGButton
            type="Primary"
            onClick={() => {
              if (!isLoadingSubmitForm) {
                setSubmitType("Draff");
              }
            }}
          >
            Save Draft
          </AGButton>
          <AGButton
            type="Success"
            onClick={() => {
              if (!isLoadingSubmitForm) {
                setSubmitType("Publish");
              }
            }}
          >
            Publish
          </AGButton>
        </>
      }
      visible={visible}
      toolstip={true}
      titleTooltip={MODAL_CONSTANT.ADD_SECONDMENT}
    >
      <CustomBackground ref={componentRef}>
        <CommerceCompassStyled>
          <div className="print">
            <div>
              <Formik
                innerRef={formRef}
                validationSchema={CommerceSecondmentSchema}
                initialValues={
                  {
                    country:
                    {
                      value: firmAddresses?.findIndex((e) => e.fkOrgId === Number(id)),
                      label:
                        firmAddresses?.find((e) => e.fkOrgId === Number(id))?.firmName1,
                      fkOrgId: Number(id),
                      addtionalRetions: firmAddresses?.find((e) => e.fkOrgId === Number(id))?.additionRegions
                    },
                    region: (!user?.roles.includes("Admin") || user!.individual.fkOrgId !== Number(id) ) ? undefined :
                    {
                      value: agnetRegion?.find((e) => e.netRegionId === regionId)?.netRegionId,
                      label: agnetRegion?.find((e) => e.netRegionId === regionId)?.netRegionName,
                    },
                    today: new Date(),
                    keyContact: [],
                    firmId: id || user?.individual.fkOrgId,
                    interestType:
                      interestType?.map((e) => {
                        return {
                          value: e.secondmentInterestTypeId,
                          label: e.secondmentInterestType,
                          isChecked: e.isChecked,
                        };
                      }) || [],
                  } as any
                }
                validateOnChange={submitCount >= 1}
                onSubmit={(values) => {
                  if (submitType !== undefined) {
                    const data = {
                      fkFirmId: values.firmId,
                      dateEntered: moment(values.today).toISOString(),
                      detailedDescription: values.detailedDescription.trim() ?? "",
                      region: values.region.value,
                      comContactIds: values.keyContact.map((e: any) => e.value),
                      interestingType: values.interestType
                        .filter((e: any) => e.isChecked)
                        .map((e: any) => e.value),
                      mainServiceId: values.mainServiceId.value,
                      title: values.title.trim() ?? "",
                    } as any;

                    const formData = new FormData();

                    for (const key in data) {
                      const value = data[key];

                      if (Array.isArray(value)) {
                        value.forEach((item: any) => {
                          formData.append(`${key}`, JSON.stringify(item));
                        });
                      } else {
                        formData.append(key, value);
                      }
                    }

                    formData.append("type", submitType);

                    if (submitType === "Draff") {
                      formData.append("isDraff", JSON.stringify(true));
                      submitForm(formData);
                    }
                    if (submitType === "Publish") {
                      formData.append("isDraff", JSON.stringify(false));
                      submitForm(formData);
                    }
                  }
                }}
              >
                {({values, errors, setFieldValue}) => {
                  const optionInitialComSecondaryServices = values.mainServiceId
                    ? comMainService
                        ?.find((e) => e.mainServiceId === values.mainServiceId.value)
                        ?.comOfferingSecondaryServices?.map((e) => ({
                          value: e.secondaryServiceId,
                          label: e.secondaryServiceName,
                        }))
                    : [];

                  const createdService = expertiseServices.map(
                    (e: any) => e.mainService.mainServiceId,
                  );

                  let messengeError = "";

                  Object.keys(errors).forEach(function (key, index) {
                    if (key === "compracticeLevelsCustom") {
                      const compracticeLevelsCustom: any = errors[key];

                      return (messengeError += compracticeLevelsCustom.find((f: any) => f?.isValid)
                        ? "Question 7" + (index === Object.keys(errors).length - 1 ? "." : ", ")
                        : "");
                    }

                    return (messengeError +=
                      errors[key]?.toString().replace("_", "").replace("+", "") +
                      (index === Object.keys(errors).length - 1 ? "." : ", "));
                  });
                  return (
                    <form>
                        <div>
                          <label
                            className="label-title"
                            htmlFor=""
                          >
                            Organization Region: <span className="required">*</span>
                          </label>
                          <div className="subtitle">
                            <span>Please select the Region.</span>
                          </div>
                          <div className="custom-select">
                            <AGSelect
                              placeholder="Enter/ Select organization region"
                              onChange={(e: any) => {
                                getFirmAddresses({id: e?.value as any});
                                // setFieldValue("keyContact", "");
                                setFieldValue("region", e);
                                // if (e) {
                                //   setFieldValue("country", "");
                                // }
                                if ( values.country && !values.country?.addtionalRetions?.includes(e.value)) {
                                  setFieldValue("country", "");
                                }
                              }}
                              value={values.region}
                              options={agnetRegion?.map((e) => {
                                return {
                                  value: e.netRegionId,
                                  label: e.netRegionName,
                                };
                              })}
                              // isDisabled={Number(id) !== ADMIN_ORGANIZATION.ID}
                            />
                            {errors.region && (
                              <div className="error">This question is required. </div>
                            )}
                          </div>
                        </div>
                      <RolesHandle
                        firmId={ADMIN_ORGANIZATION.ID}
                        fkOrgId={ADMIN_ORGANIZATION.ID}
                        roles={["Admin"]}
                      >
                        <div>
                          <label
                            className="label-title"
                            htmlFor=""
                          >
                            Organization Name: <span className="required">*</span>
                          </label>
                          <div className="subtitle">
                            <span>Please Select Organization.</span>
                          </div>
                          <AGSelect
                            placeholder="Enter/ Select organization name"
                            value={values.country}
                            onChange={(e: any) => {
                              getIndividuals(e?.fkOrgId as any);
                              setFieldValue("firmId", e?.fkOrgId);
                              setFieldValue("keyContact", "");
                              setFieldValue("country", e);
                              if (e) {
                                getServices(e.fkOrgId);
                              }
                            }}
                            options={firmAddresses
                              ?.filter((e) => e.orgType === 1)
                              .map((e, index) => {
                                return {
                                  value: index,
                                  label: e.firmName1,
                                  fkOrgId: e.fkOrgId,
                                  addtionalRetions: e.additionRegions,
                                //   disabled:
                                //     e.createdSecondments &&
                                //     e.createdSecondments >=
                                //       user?.individual.secondmentMaximumQuantity!
                                //       ? true
                                //       : false,
                                };
                              })}
                            // isOptionDisabled={(option: any) => option.disabled}
                            isDisabled={Number(id) !== ADMIN_ORGANIZATION.ID}
                          />
                          {errors.country && (
                            <div className="error">This question is required. </div>
                          )}
                        </div>
                      </RolesHandle>

                      <div>
                        <label className="label-title">
                          Title: <span className="required">{" "}*
                          {/* <Tooltip
                              text={
                                <div className="tool-tip">
                                  Provide a short description of the secondment, including the expected start date and how long the assignment will last. This helps align expectations and identify the right match.
                                </div>
                              }
                            /> */}
                          </span>
                        </label>
                        <div
                          data-tip="Tooltip content"
                          className="subtitle"
                        >
                          Please enter the secondment title.
                        </div>
                        <AGInput
                          maxLength={150}
                          placeholder="Enter your answer"
                          // className="text-area"
                          onChange={(e) => {
                            setFieldValue("title", e.target.value);
                          }}
                        />
                        {errors.title && (
                          <div className="error">This question is required.</div>
                        )}
                      </div>

                      <div>
                        <label
                          className="label-title"
                          htmlFor=""
                        >
                          Key Contact(s): <span className="required">*</span>
                        </label>
                        <div
                          data-tip="Tooltip content"
                          className="subtitle"
                        >
                          Select a maximum of 3 key contacts. If a key contact for your organization
                          isn’t listed, ask your organization’s AG Champion to get them added to our
                          database.
                        </div>
                        <AGSelect
                          placeholder="Enter/ Select your answer"
                          value={values.keyContact}
                          onChange={(e: any) => {
                            if (e.length > 3) {
                              setFieldValue("keyContact", e.slice(1, 4));
                            } else {
                              setFieldValue("keyContact", e);
                            }
                          }}
                          options={individual
                            ?.sort((a, b) =>
                              a.firstName + " " + a.lastName > b.firstName + " " + b.lastName
                                ? 1
                                : b.firstName + " " + b.lastName > a.firstName + " " + a.lastName
                                ? -1
                                : 0,
                            )
                            .map((e) => {
                              return {
                                value: e.individualId,
                                label: e.firstName + " " + e.lastName,
                              };
                            })}
                          isMulti
                        />
                        {errors.keyContact && (
                          <div className="error">This question is required.</div>
                        )}
                      </div>

                      <label className="label-title">
                        Interest Type: <span className="required">*
                        <Tooltip
                            text={
                              <div className="tool-tip">
                                Let us know if your firm is offering or seeking a secondee and the area of specialization.
                              </div>
                            }
                          />  
                        </span>
                      </label>
                      <div
                        style={{
                          borderRadius: "7px",
                          padding: "0px 10px",
                          border: "1px solid rgb(223, 228, 234)",
                        }}
                      >
                        {interestType?.map((e: any, index: number) => (
                          <label
                            key={index}
                            style={{
                              marginTop: 10,
                              marginBottom: 20,
                              display: "flex",
                              gap: 10,
                              alignItems: "start",
                            }}
                            className="flex items-center"
                          >
                            <AGCheckbox
                              defaultChecked={values.interestType[index].isChecked}
                              value={values.interestType[index].isChecked}
                              onChange={() => {
                                setFieldValue(
                                  `interestType.${index}.isChecked`,
                                  !values.interestType[index].isChecked,
                                );
                              }}
                            />
                            <div>
                              <span className="service-available-options">
                                {e.secondmentInterestType}
                              </span>
                            </div>
                          </label>
                        ))}
                      </div>
                      {errors.interestType && (
                        <div className="error">This question is required.</div>
                      )}
                      <div>
                        <label
                          className="label-title"
                          htmlFor=""
                        >
                          Specialized Service:{" "}
                          <span className="required">
                            {" "}
                            *
                            <Tooltip
                              text={
                                <div className="tool-tip">
                                  Select a specialized service area to feature.
                                  Complete and submit another Commerce Service Profile for any additional specialized services you wish to feature.
                                  If you would like to feature a specialized service area that is not listed,
                                  please email{" "}
                                  <a
                                    href={`mailto:${
                                      process.env.REACT_APP_CONTACT_SUPPORT_MAIL ||
                                      "techsupport@allinialglobal.com"
                                    }`}
                                    className="linkified"
                                  >
                                    {process.env.REACT_APP_CONTACT_SUPPORT_MAIL ||
                                      "techsupport@allinialglobal.com"}
                                  </a>{" "}
                                  to request it to be added.
                                </div>
                              }
                            />
                          </span>
                        </label>
                        <div>
                          <AGSelect
                            placeholder="Enter/ Select Specialized Service"
                            value={values.mainServiceId}
                            onChange={(e: any) => {
                              setFieldValue("mainServiceId", e);
                            }}
                            options={comMainService
                              ?.sort((a, b) => a.mainServiceName!.localeCompare(b.mainServiceName!))
                              .map((e) => {
                                return {
                                  value: e.mainServiceId,
                                  label: e.mainServiceName,
                                  // disabled: createdService.some(
                                  //   (f: number) => f === e.mainServiceId,
                                  // ),
                                };
                              })}
                            // isOptionDisabled={(option: any) => option.disabled}
                          />
                        </div>
                        {errors.mainServiceId && (
                          <div className="error">This question is required.</div>
                        )}
                      </div>
                      <div>
                        <label className="label-title">
                          Duration & Description: <span className="required">{" "}*
                          <Tooltip
                              text={
                                <div className="tool-tip">
                                  Provide a short description of the secondment, including the expected start date and how long the assignment will last. This helps align expectations and identify the right match.
                                </div>
                              }
                            />
                          </span>
                        </label>
                        <div
                          data-tip="Tooltip content"
                          className="subtitle"
                        >
                          Please enter the duration & description of secondment.
                        </div>
                        <AGtextarea
                          maxLength={300}
                          placeholder="Enter your answer"
                          className="text-area"
                          onChange={(e) => {
                            setFieldValue("detailedDescription", e.target.value);
                          }}
                        />
                        {errors.detailedDescription && (
                          <div className="error">This question is required.</div>
                        )}
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </CommerceCompassStyled>
      </CustomBackground>
    </AGModal>
  );
};
export default AddSecondmentModal;

const PlusIcon = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0748 7.00797H10.3598V0.292969H7.63981V7.00797H0.924805V9.72797H7.63981V16.443H10.3598V9.72797H17.0748V7.00797Z"
        fill="#0971A2"
      />
    </svg>
  );
};

const MinusIcon = () => {
  return (
    <svg
      width={15}
      viewBox="0 0 24 24"
      fill="rgb(44, 118, 170)"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="SVGRepo_bgCarrier"
        strokeWidth="0"
      ></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M6 12L18 12"
          stroke="rgb(44, 118, 170)"
          strokeWidth="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
};
